import type { FieldValues } from "react-hook-form";

import { CustomCheckbox, CustomLabel } from "@/components/atoms";
import { FormControl, FormField, FormItem } from "@/components/ui/form";

import type { SelectOptionsProps } from "../SelectOptions";

const RadioSelect = <T extends FieldValues>({
  selectList,
  title,
  form,
  name,
}: SelectOptionsProps<T>) => (
  <FormField
    control={form}
    name={name}
    render={({ field }) => {
      const selected: string = field.value ?? "";

      return (
        <FormItem
          className="gap-3"
          data-testid={`select-options-field-${String(name)}`}
        >
          <p className="text-sm text-gray-950">{title}</p>
          <div className="flex flex-col gap-3">
            {selectList.map(({ id, name }) => (
              <FormItem key={id} className="flex items-center gap-2">
                <FormControl>
                  <CustomCheckbox
                    id={id}
                    checked={selected === id}
                    onCheckedChange={() => field.onChange(id)}
                    data-testid={`base-select-radio-${id}`}
                  />
                </FormControl>{" "}
                <CustomLabel htmlFor={id} label={name} />{" "}
              </FormItem>
            ))}
          </div>
        </FormItem>
      );
    }}
  />
);

export default RadioSelect;
